/**
 * Mobile menu (#menu-toggle + .resp-menu) — port 1:1 din legacy common.js
 * lines 2495-2552.
 *
 * Toggle hamburger + sub-menu open via data-id + back button + body close.
 * Variabila `secList` e modulara (acelasi scope cu IIFE legacy original).
 */

import { $ } from '../core/selector.js';

export function initMobileMenu(): void {
    let secList: Element | null = null;

    const closeMobMenu = (): void => {
        ($('#menu-toggle') as Element | null)?.classList.remove('open');
        ($('.resp-menu .rm-navbar') as Element | null)?.classList.remove('active');
        ($('.resp-menu.opened') as Element | null)?.classList.remove('opened');
        secList?.classList.remove('opened');
        ($('.resp-menu') as Element | null)?.addEventListener('transitionend', () => {
            secList?.classList.remove('opened');
            secList = null;
        }, { once: true });
    };

    const toggleMobMenu = (e: Event): void => {
        e.stopPropagation();
        const target = (e.currentTarget as Element);
        const hasOpened = target.classList.contains('open');

        ($('.resp-menu') as Element | null)?.classList.toggle('opened');

        if (hasOpened) {
            ($('.resp-menu .rm-navbar') as Element | null)?.classList.remove('active');
            ($('.resp-menu') as Element | null)?.addEventListener('transitionend', () => {
                secList?.classList.remove('opened');
                secList = null;
            }, { once: true });
        }
        ($('#menu-toggle') as Element | null)?.classList.toggle('open');
    };

    ($('#menu-toggle') as Element | null)?.on('click', (e: Event) => toggleMobMenu(e));
    ($('body') as Element | null)?.on('click', () => closeMobMenu());

    ($('.resp-menu .rm-list') as Element | null)?.on('click', 'li > a', function (this: HTMLElement) {
        ($('.resp-menu .rm-navbar') as Element | null)?.classList.add('active');
        secList = $(`.resp-menu .rm-sec-list[data-id="${this.dataset['id']}"]`) as Element | null;
        secList?.classList.add('opened');
    });

    ($('.resp-menu .rm-back') as Element | null)?.on('click', () => {
        ($('.resp-menu .rm-navbar') as Element | null)?.classList.remove('active');
        secList?.classList.remove('opened');
        secList = null;
    });

    ($('.resp-menu') as Element | null)?.on('click', (e: Event) => e.stopPropagation());
}
